import { keyframes, css } from 'styled-components';
import UserAgentUtils from './userAgent';

const hexToRgba = (color: string, opacityPercent: number): string => {
	if (color === 'transparent') {
		return color;
	}

	const hexToR = parseInt(color.substring(1, 3), 16);
	const hexToG = parseInt(color.substring(3, 5), 16);
	const hexToB = parseInt(color.substring(5, 7), 16);
	const alpha = (opacityPercent / 100).toPrecision(2);

	return `rgba(${hexToR}, ${hexToG}, ${hexToB}, ${alpha})`;
};

const spinKeyFrame = keyframes`
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
`;

const spin = css`${spinKeyFrame} ${'2s linear infinite;'}`;

const overlayAnimation = (isOpen: boolean) => {
	return `
		transition: opacity .4s cubic-bezier(.25,.8,.25,1);
		opacity: ${ isOpen ? 1 : 0};
		pointer-events: ${ isOpen ? 'auto' : 'none'};
	`;
};

const isSupportingBackdropBlur = (): boolean => {
	if (typeof CSS === 'undefined') {
		// Browsers that don't support this API also don't support backdrop-filter
		return false;
	}

	if (UserAgentUtils.isChrome() && UserAgentUtils.isDesktop()) {
		// Disabling it for now on chrome desktop
		// Chrome 76 have rendering error when hovering other tabs, https://stackoverflow.com/questions/57736567
		return false;
	}

	if (UserAgentUtils.isAndroidApp()) {
		// Disabling it for now on android webview
		// newer version of android's webview says it supports the ruel
		// but the background was fully black instead of transparent and blurry
		return false;
	}

	return CSS.supports('backdrop-filter', 'blur(20px)')
		|| CSS.supports('-webkit-backdrop-filter', 'blur(20px)');
};

export {
	hexToRgba,
	spin,
	overlayAnimation,
	isSupportingBackdropBlur,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/style.ts